// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-cd01d3b0] {\n\tword-break:keep-all;\n}\n", ""]);
// Exports
module.exports = exports;
